<template>
  <div >
    <list ref="list" >
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" v-if="!IssueIsApproval" @click="onOrderRelease" icon="el-icon">工单下达</el-button>
        <el-button type="primary" v-if="!IssueIsApproval" @click="onOrderPrint" style="margin-bottom: 5px;" icon="el-icon">下达打印</el-button>
        <el-button type="primary" v-if="!IssueIsApproval" @click="onOffOrder" icon="el-icon">取消下达</el-button>
        <el-button type="primary" v-if="IssueIsApproval" @click="examineArr" icon="el-icon">批量审批</el-button>
        <el-button type="primary" v-if="IssueIsApproval" @click="AbandonmentArr" icon="el-icon">批量弃审</el-button>
        <el-button type="primary" @click="openOrder" icon="el-icon-plus">添加工单</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="160">
          <template slot-scope="{ row }">
            <el-button key="btn1" type="text" @click="end(row)" :disabled="row.Status === 7||row.Status===5" v-if="row.Status!==5&&row.Status!=7">完结</el-button>
            <el-button key="btn6" type="text" @click="revokeClose(row)"  v-if="row.Status===5||row.Status === 7" >取消完结</el-button>
            <el-button key="btn2" type="text" @click="unbinding(row)" v-if="row.Status!==5">解绑</el-button>
            <el-button key="btn3" type="text" v-if="row.Status>=3" @click="details(row)" >查看</el-button>
            <el-button key="btn4" type="text" v-else @click="details(row)">编辑</el-button>
            <el-button key="btn5" type="text" @click="toPrint(row)">打印</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <release-dialog ref="releaseDialog" :lineData="lineData" @saved="reload" @onClosed="onClosed"></release-dialog>
    <detail-dialog ref="detailDialog"></detail-dialog>
    <edit-dialog ref="editDialog"  @saved="reload" @onClosed="onClosed" v-if="hackReset"></edit-dialog>
    <qua-dialog ref="quaDialog" @saved="reload"></qua-dialog>
    <unbinding-dialog ref="unbindingDialog"  @select="submit"></unbinding-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/production/ticketmanagement/workorder/assemble/list";
import detailDialog from "@/components/production/ticketmanagement/workorder/assemble/detailDialog";
import editDialog from "@/components/production/ticketmanagement/workorder/assemble/editDialog";
import quaDialog from "@/components/production/ticketmanagement/workorder/quaDialog";
import unbindingDialog from "@/components/production/ticketmanagement/workorder/unbindingDialog";
import releaseDialog from "@/components/production/ticketmanagement/workorder/releaseDialog";


export default {
  name: "workorder",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
    editDialog,
    quaDialog,
    unbindingDialog,
    releaseDialog,
  },
  data() {
    return {
      api: require("@/api/production/workDoc").default,
      unBindMaterialApi: require("@/api/production/unBindMaterial").default,
      workDocApi: require("@/api/production/workDoc").default,
      optionApi: require("@/api/sy/option").default,
      hackReset:false,
      lineData:[],
      IssueIsApproval: false
    };
  },
  activated() {
    this.optionApi.getWorkDocSetting().then((res) => {
      if (res.Code === 0) {
        this.IssueIsApproval = res.Data.IssueIsApproval
      }
    });
  },
  methods: {
    submit(data){
      console.log('data', data)
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.unBindMaterialApi.submit(data).then(res => {
        loading.close();
        if(res.Code === 0){
          this.$message.success(res.Msg)
        }else{
          this.$message.warning(res.Msg)
        }
      }).catch(err => {
        loading.close();
      })
    },
    end(row){
      console.log(row,"row")
      this.$refs.quaDialog.openDetails(row)
    },
    unbinding({WorkDocId}){
      this.$refs.unbindingDialog.open().then(that => {
        that.getData(WorkDocId);
      })
    },
    revokeClose(row){
      this.api.revokeClose(row.WorkDocId).then(res => {
        if(res.Code === 0){
          this.$message.success(res.Msg)
          this.reload();
        }else{
          this.$message.warning(res.Msg)
        }
      })
    },
    examineArr(){
      //checkedRows
      let checkedRows=this.$refs.list.$refs.list.checkedRows
     if(checkedRows.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据进行审批'})
     let el=  checkedRows.find(el=>el.Status==3)
    if(el)return this.$message({type: 'warning', message: '勾选的单据有已审批内容'})
    let Ids =[]
    checkedRows.forEach(item=>{
      Ids.push(item.WorkDocId)
    })
    this.api.getReview({Ids:Ids}).then(res=>{
      if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
    })


    },
    AbandonmentArr(){      
      let checkedRows=this.$refs.list.$refs.list.checkedRows
     if(checkedRows.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据进行弃审'})
    let el=  checkedRows.find(el=>el.Status!=3)
    if(el)return this.$message({type: 'warning', message: '勾选的单据包含未审批内容'})
    let Ids =[]
    checkedRows.forEach(item=>{
      Ids.push(item.WorkDocId)
    })
    this.api.Back({Ids:Ids}).then(res=>{
      if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
    })
    },
    onClosed(){
      this.$nextTick(function(){
			// 加载
      this.hackReset = false
		})
    
    },
    openOrder(){
      this.hackReset = true;
      this.$nextTick(function(){
			this.$refs.editDialog.open()
		})     
    },
    delRows(){
      this.$refs.list.del();
    },
     details({WorkDocId}){
      this.$refs.detailDialog.openDetailsById(WorkDocId)
      console.log(this.$refs.detailDialog,'this.$refs.detailDialog')
    },
    toPrint(row) {
      let newpage = this.$router.resolve({
        path: '/workorderPrint?id=' + row.WorkDocId + "&t=3"
      })
      window.open(newpage.href, '_blank');
    },
    /** 下达打印 */
    onOrderPrint(){
      this.lineData = this.$refs.list.$refs.list.checkedRows
      if(this.lineData.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据'})
      let checkedRows=this.$refs.list.$refs.list.checkedRows
      // 判断每个对象的ReleaseDocNo属性值是否一致
      var WorkDocIds = []
      let isSameReleaseDocNo = checkedRows.every(item => item.ReleaseDocNo !== null && item.ReleaseDocNo !== '' && item.ReleaseDocNo === checkedRows[0].ReleaseDocNo);
      console.log('checkedRows',checkedRows)
      checkedRows.forEach((item) => {
        WorkDocIds.push(item.WorkDocId)
      })
      if(isSameReleaseDocNo){
        this.toPrint1(WorkDocIds)
      }else{
        this.$message.warning("已下达且同一下达号才能合并打印！");
      }
    },
    toPrint1(ids) {
      let newpage = this.$router.resolve({
        path: '/workorderPrint1?ids=' + ids + "&t=3"
      })
      window.open(newpage.href, '_blank');
    },
    /** 工单下达 */
    onOrderRelease(){
      this.lineData = this.$refs.list.$refs.list.checkedRows
      if(this.lineData.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据'})
      this.$refs.releaseDialog.open()
    },
    /** 取消下达 */
    onOffOrder(){
      this.lineData = this.$refs.list.$refs.list.checkedRows
      if(this.lineData.length==0)return  this.$message({type: 'warning', message: '请至少勾选一张单据'})
      let checkedRows=this.$refs.list.$refs.list.checkedRows
      // 判断每个对象的ReleaseDocNo属性值是否一致
      var WorkDocIds = []
      let isSameReleaseDocNo = checkedRows.every(item => item.ReleaseDocNo !== null && item.ReleaseDocNo !== '' &&item.ReleaseDocNo === checkedRows[0].ReleaseDocNo);
      checkedRows.forEach((item) => {
        WorkDocIds.push(item.WorkDocId)
      })
      if(isSameReleaseDocNo){
        this.$confirm("确认取消下达吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
            this.workDocApi.releaseCancel({WorkDocIds:WorkDocIds}).then(res=>{
            if (res.Code == 0) {
              this.$message.success("取消下达成功");
              this.reload();
            } else {
              this.$message.warning(res.Msg);
              this.reload();
            }
          })
        })
      }else{
        this.$message.warning("请选择已下达工单且不同下达号不能一同取消！")
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.count {
  margin-right: 15px;
  font-size: 14px;
  color: red;
  display: inline-block;
}
</style>